export default {"src":"/_next/static/media/icon-no-text.78ff8b75.svg","height":24,"width":21,"blurWidth":0,"blurHeight":0};